// --- config
const PLACEHOLDER =
  "https://cdn.shopify.com/s/files/1/0781/5430/1770/files/bag_paceholder.webp"; 

// --- helpers: parse and format prices robustly
function extractCurrencyAndSeparators(priceText) {
  const symbolMatch = priceText.match(/[^0-9\s.,\-]+/);
  const symbol = symbolMatch ? symbolMatch[0] : "";
  const lastComma = priceText.lastIndexOf(",");
  const lastDot = priceText.lastIndexOf(".");
  const usesCommaDecimal = lastComma > lastDot;
  return { symbol, usesCommaDecimal };
}

function parsePriceStringToFloat(priceText) {
  if (!priceText || !priceText.trim()) return 0;
  let cleaned = priceText.replace(/[^\d.,\-]/g, "").trim();

  const hasComma = cleaned.indexOf(",") !== -1;
  const hasDot = cleaned.indexOf(".") !== -1;

  if (hasComma && hasDot) {
    // Case like "10.965,00" → dot = thousands, comma = decimal
    cleaned = cleaned.replace(/\./g, "").replace(/,/g, ".");
  } else if (hasComma && !hasDot) {
    // Case like "129,00" → comma = decimal
    cleaned = cleaned.replace(/,/g, ".");
  } else {
    // Case like "12995.00" → dot = decimal
    cleaned = cleaned.replace(/\s/g, "");
  }

  const num = parseFloat(cleaned);
  return isNaN(num) ? 0 : num;
}

function formatNumberToPriceString(amount, symbol = "€", usesCommaDecimal = false) {
  const fixed = (Math.round((amount + Number.EPSILON) * 100) / 100).toFixed(2);
  if (usesCommaDecimal) {
    const parts = fixed.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return `${symbol}${parts[0]},${parts[1]}`;
  } else {
    const parts = fixed.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return `${symbol}${parts[0]}.${parts[1]}`;
  }
}

// --- DOM updates
function updateDisplayPrices($bundle) {
  const priceText1 = $bundle.attr("variant_price1") || "";
  const priceText2 = $bundle.attr("variant_price2") || "";

  const sample = priceText1 || priceText2 || "";
  const { symbol, usesCommaDecimal } = extractCurrencyAndSeparators(sample || "€");

  const p1 = parsePriceStringToFloat(priceText1);
  const p2 = parsePriceStringToFloat(priceText2);

  const compareTotal = p1 + p2;

  // get discount percent
  const attr = $bundle.attr("data-discount-percent");
  let discountPercent = 0;
  if (typeof attr !== "undefined") {
    const parsed = parseFloat(attr);
    discountPercent = isNaN(parsed) ? 0 : parsed;
  } else if (typeof window.BUNDLE_DISCOUNT_PERCENT !== "undefined") {
    const parsed = parseFloat(window.BUNDLE_DISCOUNT_PERCENT);
    discountPercent = isNaN(parsed) ? 0 : parsed;
  } else {
    discountPercent = 0;
  }
  discountPercent = Math.max(0, Math.min(100, discountPercent));
console.log('discount_percent:'+discountPercent);
  // ---------- FIXED: divide by 100 so percentage is applied correctly ----------
  const discountedTotal = Math.round((compareTotal * (100 - discountPercent) / 100 + Number.EPSILON) * 100) / 100;
  const savings = Math.round((compareTotal - discountedTotal + Number.EPSILON) * 100) / 100;
  // ---------------------------------------------------------------------------

  const $priceLeft = $(".price_richtext_main_left");
  if ($priceLeft.length) {
    $priceLeft.find("s").text(formatNumberToPriceString(compareTotal, symbol || "€", usesCommaDecimal));
    $priceLeft.find(".product_price").text(formatNumberToPriceString(discountedTotal, symbol || "€", usesCommaDecimal));
  } else {
    $("s").first().text(formatNumberToPriceString(compareTotal, symbol || "€", usesCommaDecimal));
    $(".product_price").first().text(formatNumberToPriceString(discountedTotal, symbol || "€", usesCommaDecimal));
  }

 const $save = $(".save span");
if ($save.length) {
  // Calculate percentage savings relative to compareTotal
  const savingPercent = compareTotal > 0 ? Math.round((savings / compareTotal) * 100) : 0;
  $save.text(savingPercent + "%");
}
}

// --- helpers to set/clear slots (also handle price storing)
function setSlot($bundle, slot, variantId, imgSrc, priceText, title) {
  $bundle.attr(`variant_id${slot}`, variantId);
  $bundle.attr(`title${slot}`, title);
  if (typeof priceText !== "undefined" && priceText !== null) {
    $bundle.attr(`variant_price${slot}`, priceText);
  }
  const $slot = $bundle.find(`.bundle_button_variant_image.variant_id${slot}`);
  $slot.removeClass("empty");
  $slot.find("img.variant_image").attr({
    src: imgSrc,
    alt: `variant ${variantId}`,
  });
  updateDisplayPrices($bundle);
}

function clearSlot($bundle, slot) {
  $bundle.removeAttr(`variant_id${slot}`);
  $bundle.removeAttr(`title${slot}`);
  $bundle.removeAttr(`variant_price${slot}`);
  const $slot = $bundle.find(`.bundle_button_variant_image.variant_id${slot}`);
  $slot.addClass("empty");
  $slot.find("img.variant_image").attr({ src: PLACEHOLDER, alt: "placeholder" });
  updateDisplayPrices($bundle);
  $('.product_slider_custom_slider_new_item').removeClass('hk_active');
  var id_1 = $bundle.attr("variant_id1");
  var id_2 = $bundle.attr("variant_id2");
  $('.product_slider_custom_slider_new_item[variant_id="'+id_1+'"]').addClass('hk_active');
  $('.product_slider_custom_slider_new_item[variant_id="'+id_2+'"]').addClass('hk_active');
}

function updateButtonState($bundle) {
  const filled1 = !!$bundle.attr("variant_id1");
  const filled2 = !!$bundle.attr("variant_id2");
  if (filled1 && filled2) {
    $bundle.removeAttr("disabled");
  } else {
    $bundle.attr("disabled", "disabled");
  }
}

// --- select from product tiles
$(document).on("click", ".product_slider_custom_slider_new_item", function () {
  $('.product_slider_custom_slider_new_item').removeClass('hk_active');
  const variantId = $(this).attr("variant_id");
  const title = $(this).attr("title");
  const imgSrc = $(this).find(".product_image_top img").attr("src") || PLACEHOLDER;
  const priceText = $(this).find(".product_text_price").text().trim() || "";
  const $bundle = $(".bundle_button_main").first();
  const id1 = $bundle.attr("variant_id1");
  const id2 = $bundle.attr("variant_id2");

  if (!id1) {
    setSlot($bundle, 1, variantId, imgSrc, priceText,title);
  } else if (!id2) {
    setSlot($bundle, 2, variantId, imgSrc, priceText,title);
  } else {
    setSlot($bundle, 2, variantId, imgSrc, priceText,title);
  }

  updateButtonState($bundle);


  
  var id_1 = $bundle.attr("variant_id1");
  var id_2 = $bundle.attr("variant_id2");
  $('.product_slider_custom_slider_new_item[variant_id="'+id_1+'"]').addClass('hk_active');
  $('.product_slider_custom_slider_new_item[variant_id="'+id_2+'"]').addClass('hk_active');
});

$(document).on("click", ".bundle_button_variant_image .remove_variant", function (e) {
  e.preventDefault();
  e.stopPropagation();
  const $slot = $(this).closest(".bundle_button_variant_image");
  const $bundle = $slot.closest(".bundle_button_main");
  const slot = $slot.hasClass("variant_id1") ? 1 : 2;
  clearSlot($bundle, slot);
  updateButtonState($bundle);
});

$(function () {
  const $bundle = $(".bundle_button_main").first();
  updateButtonState($bundle);
  updateDisplayPrices($bundle);
});



/*
$(document).on("click", '.bundle_button_main:not([disabled])', function(e) { 
var items = [];
var variant_id1 = $(this).attr('variant_id1');
var variant_id2 = $(this).attr('variant_id2');
  items.push({
    id: variant_id1,
    quantity: 1
  });
  items.push({
    id: variant_id2,
    quantity: 1
  });

if (items.length) {
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      items: items
    },
    dataType: 'json',
    success: function () {

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', { bubbles: true })
      );
        document.getElementById('mini-cart').open = true;

    }
  });
}
  });*/

$(document).on("click", '.custom_personalization_trigger_buy:not([disabled])', function(e) { 
$('.bundle_button_main').trigger('click');
});

  